<template>
  <div class="user-tournament-summary">
    <TournamentProfileCard :participant="(participantData !==null && participantData)" :countryCode="countryCode" :brokerAccount="{
      identifier: participantData?.brokerAccountIdentifier || undefined
    }" :swisetRatio="participantData?.score" :rank="participantData ? getRank(): 0" :shareBtnCallback="()=>{}" :changeAccountCallback="openChangeAccountModal" :canChangeAcc="canChangeAcc"/>
    <v-card class="pa-5 desktop-card" outlined style="background-color: rgba(0,0,0,0)" v-if="false">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-avatar size="84">
            <v-img :src="participantData.profilePicture != null ? participantData.profilePicture :
              'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" />
          </v-avatar>
        </v-row>
        <v-row align="center" class="mt-5" justify="center">
          <div>
            <h2 class="text-center">
              {{ basicUserInfo }}
              <Flag v-if="countryCode !== null" :code="countryCode" size="S" />
            </h2>
            <p class="text-center d-flex align-center">{{ $t('joinedWith') }}
              {{ participantData.brokerAccountIdentifier }} -
              {{ participantData.brokerName }}
              <v-btn v-if="canChangeAcc" class="ml-1 change-btn" rounded @click="updateAccModal = true"><v-icon>fa-shuffle</v-icon></v-btn>
            </p>
            <v-chip v-if="notConsistent" class="d-flex justify-center text-center my-2" color="warning" small>
              {{ (notPositive) ? $t('alerts.notPositive') : $t('alerts.notConsistent') }}
              <v-icon class="ml-2" color="white" small>fa-exclamation-circle</v-icon>
            </v-chip>
            <DisqualificationTooltip v-else-if="disqualified" :participant-id="participantData.participantId" position="bottom">
              <v-chip class="d-flex justify-center text-center my-2" color="error" small>
                {{ $t('alerts.disqualified') }}
                <v-icon class="ml-2" color="white" small>fa-exclamation-triangle</v-icon>
              </v-chip>
            </DisqualificationTooltip>
            <h3 v-if="participantData.status === 'ACTIVE'" class="text-center mt-2">
              {{ $t(`rankTypes.${rankingType}`) }}:
              {{ participantData.score !== null ? (rankingType.includes('PERCENTAGE')) ? `${(participantData.score *
                100).toFixed(2)}%` :
                participantData.score.toFixed(2) : '---' }}
              &nbsp; | &nbsp;
              {{ getRank() }} ° {{ $t('atRank') }}</h3>
            <!--v-btn class="mt-3" style="width: 100%" @click="seeDistribution">
            {{ $t('btnDistribution') }}
            <v-icon v-if="participantData.participantStatus === 'PAUSED'" class="ml-2" color="red darken-1" small>
              fa-exclamation-circle
            </v-icon>
          </v-btn-->
          </div>
        </v-row>
      </v-container>
    </v-card>
    <div v-if="participantData && false">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-row class="d-flex justify-center">
            <v-col cols="3" class="d-flex align-center justify-center">
              <v-avatar size="76">
                <v-img :src="participantData?.profilePicture != null ? participantData?.profilePicture :
                  'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" />
              </v-avatar>
            </v-col>
            <div class="col col-9">
              <h2 style="font-weight: bold;" class="text-start mb-2">
                {{ basicUserInfo }}
                <Flag v-if="countryCode !== null" :code="countryCode" size="S" />
              </h2>
              <p style="font-weight: normal;" class="text-start">{{ $t('joinedWith') }}
                {{ participantData.brokerAccountIdentifier }} -
                {{ participantData.brokerName }}
              </p>
              <v-chip v-if="notConsistent" class="d-flex justify-center text-start my-2" color="warning" small>
                {{ (notPositive) ? $t('alerts.notPositive') : $t('alerts.notConsistent') }}
                <v-icon class="ml-2" color="white" small>fa-exclamation-circle</v-icon>
              </v-chip>
              <DisqualificationTooltip v-else-if="disqualified" :participant-id="participantData.participantId" position="bottom">
                <v-chip class="d-flex justify-center text-start my-2" color="error" small>
                  {{ $t('alerts.disqualified') }}
                  <v-icon class="ml-2" color="white" small>fa-exclamation-triangle</v-icon>
                </v-chip>
              </DisqualificationTooltip>
              <h3 v-if="participantData.status === 'ACTIVE'" class="text-start">
                {{ $t(`rankTypes.${rankingType}`) }}:
                {{ participantData.score !== null ? (rankingType.includes('PERCENTAGE')) ? `${(participantData.score *
                  100).toFixed(2)}%` :
                  participantData.score.toFixed(2) : '---' }}
                &nbsp; | &nbsp;
                {{ getRank() }} ° {{ $t('atRank') }}</h3>
            </div>
          </v-row>
        </v-row>
      </v-col>
    </div>
    <v-overlay class="register-overlay"  :dark="false" absolute v-model="updateAccModal" opacity="0.3">
      <v-btn @click="updateAccModal = false" plain retain-focus-on-click icon absolute style="z-index: 2; right: 0; background-color: transparent;"><v-icon>fa-regular fa-times</v-icon></v-btn>
      <TournamentRegisterCollapsed :participantData="participantData" :forUpdateAcc="true" :hideModal="()=>{
        updateAccModal = false
        showMsg = true
        return
        }" />
    </v-overlay>
    <v-snackbar color="var(--v-mainGreen-base)" v-model="showMsg">
      {{ $t("success") }}
    </v-snackbar>
  </div>
</template>

<script>
import CountriesData from "@/views/Register/countries";
import TournamentRegisterCollapsed from "./TournamentRegisterCollapsed.vue";
import TournamentProfileCard from "../../../components/TournamentProfileCard.vue";
import DisqualificationTooltip from "@/components/DisqualificationTooltip.vue";
export default {
  name: "UserSummary",
  components:{
    TournamentRegisterCollapsed,
    TournamentProfileCard,
    DisqualificationTooltip
  },
  props: {
    rankingType: String,
    participants: Array,
    participantData: Object,
    canChangeAcc: Boolean,
  },
  data() {
    return {
      countries: CountriesData,
      updateAccModal: false,
      showMsg: false,
    };
  },
  computed: {
    notConsistent() {
      return (this.participantData) ?
        this.participantData.status === 'PAUSED' : false;
    },
    notPositive() {
      return (this.participantData) ? // TODO Re-organize rule to be widely accepted
        this.participantData.status === 'PAUSED' && this.$store.state.tournament.tournamentOrganizerId === 54 : false;
    },
    disqualified() {
      return (this.participantData) ?
        this.participantData.status === 'DISQUALIFIED' : false;
    },
    basicUserInfo() {
      return (this.participantData) ?
        `${this.participantData.firstName} ${this.participantData.lastName}` : '';
    },
    countryCode() {
      let countryFound = this.countries.find((country) => country.name === this?.participantData?.country  || country.name === this.$store.state.user.details.country);
      return (countryFound !== undefined) ? countryFound.code : null;
    }
  },
  methods: {
    getRank() {
      let rankPosition = this.participants.filter((participant) => participant.status === 'ACTIVE').findIndex((activeParticipant) => activeParticipant?.participantId === this.participantData?.participantId);
      return (rankPosition === -1) ? '---' : `${rankPosition + 1}`;
    },
    seeDistribution() {
      this.$emit('seeDistribution');
    },
    openChangeAccountModal() {
      this.updateAccModal = true;
    }
  }
}
</script>



<style lang="scss">
.user-tournament-summary {
  .card-mobile {
    display: none;
  }

  @media (max-width: 1290px) {
    .desktop-card {
      display: none;
    }

    .card-mobile {
      display: block;

      h2 {
        font-size: 18px;
      }

      h3 {
        font-size: 14px;
      }

      p {
        font-size: 14px;
      }
    }
  }
  .change-btn{
    width: 20px;
    min-width: unset !important;
    background-color: transparent !important;
    border: 1px solid var(--v-mainGreen-base) !important;

    i{
      font-size: 16px;
      color: var(--v-mainGreen-base) !important;
    }
  }
}
</style>
